import { render } from "./VUEFooter.vue?vue&type=template&id=0cc2ea72"
import script from "./VUEFooter.vue?vue&type=script&lang=js"
export * from "./VUEFooter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__